export class DisabledCoupon {
    constructor() {
        this.type = "Disabled";
        this.state = { type: "Disabled" };
    }
    clear() {
        // NOTICE Intentionally empty
    }
}
